import { Fragment, useState } from "react";
import { Menu, MenuItem, ListItemIcon, ListItemText, Avatar } from "@mui/material";
import { PiCaretDownLight, PiCheckBold, PiBuildingsLight } from "react-icons/pi";
import { ApiRequest } from "GlobalFunctions";

interface Company {
  company_id: number;
  company_name: string;
  company_logo: string | null;
}

interface CompanySelectorProps {
  companyName: string;
  companyId: number | null;
}

export default function CompanySelector({ companyName, companyId }: CompanySelectorProps) {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const companiesRaw = localStorage.getItem("user_companies");
  const companies: Company[] = companiesRaw ? JSON.parse(companiesRaw) : [];

  const hasMultipleCompanies = companies.length > 1;

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    if (hasMultipleCompanies) {
      setAnchorEl(event.currentTarget);
    }
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleSwitch = (company: Company) => {
    handleClose();

    ApiRequest({
      url: "/users/switchCompany",
      method: "post",
      headers: {
        ltkn: localStorage.getItem("ltkn"),
      },
      body: {
        company_id: company.company_id,
      },
      setResponse: (response: any) => {
        if (response.status === "success") {
          window.location.reload();
        }
      },
    });
  };

  return (
    <Fragment>
      <span
        className="top_company_name"
        onClick={handleClick}
        style={{
          cursor: hasMultipleCompanies ? "pointer" : "default",
          display: "flex",
          alignItems: "center",
          gap: "4px",
        }}
      >
        {companyName}
        {hasMultipleCompanies && <PiCaretDownLight size={14} />}
      </span>

      {hasMultipleCompanies && (
        <Menu
          anchorEl={anchorEl}
          open={open}
          onClose={handleClose}
          anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
          transformOrigin={{ vertical: "top", horizontal: "left" }}
          PaperProps={{
            sx: {
              minWidth: 220,
              mt: 1,
            },
          }}
        >
          {companies.map((company) => {
            const isActive = companyId !== null && company.company_id === Number(companyId);
            return (
              <MenuItem
                key={company.company_id}
                onClick={() => !isActive && handleSwitch(company)}
                selected={isActive}
                sx={{
                  gap: 1.5,
                  py: 1,
                  opacity: isActive ? 1 : 0.85,
                  "&:hover": { opacity: 1 },
                }}
              >
                <ListItemIcon sx={{ minWidth: "auto !important" }}>
                  {company.company_logo ? (
                    <Avatar
                      src={company.company_logo}
                      sx={{ width: 28, height: 28 }}
                    />
                  ) : (
                    <Avatar sx={{ width: 28, height: 28, fontSize: 14 }}>
                      {company.company_name.charAt(0).toUpperCase()}
                    </Avatar>
                  )}
                </ListItemIcon>
                <ListItemText
                  primary={company.company_name}
                  primaryTypographyProps={{ fontSize: 13 }}
                />
                {isActive && <PiCheckBold size={14} style={{ color: "#2e7d32" }} />}
              </MenuItem>
            );
          })}
        </Menu>
      )}
    </Fragment>
  );
}
